import type { ShortMonthNames } from '@shared/formatting-utils';
import { t } from '@luna/i18n';

import type { MainCategoryName } from './MainCategories';
import type { SubCategoryName } from './SubCategories';

export const MONTH_NAME_TRANSLATION: Record<ShortMonthNames, () => string> = {
    JAN: () => t('pfm:months.month_JAN'),
    FEB: () => t('pfm:months.month_FEB'),
    MAR: () => t('pfm:months.month_MAR'),
    APR: () => t('pfm:months.month_APR'),
    MAY: () => t('pfm:months.month_MAY'),
    JUN: () => t('pfm:months.month_JUN'),
    JUL: () => t('pfm:months.month_JUL'),
    AUG: () => t('pfm:months.month_AUG'),
    SEP: () => t('pfm:months.month_SEP'),
    OCT: () => t('pfm:months.month_OCT'),
    NOV: () => t('pfm:months.month_NOV'),
    DEC: () => t('pfm:months.month_DEC'),
};

export const MAIN_CATEGORY_TRANSLATION: Record<MainCategoryName, () => string> = {
    LIVING_AND_ENERGY: () => t('pfm.mainCategories.LIVING_AND_ENERGY'),
    FOOD: () => t('pfm.mainCategories.FOOD'),
    HEALTH: () => t('pfm.mainCategories.HEALTH'),
    CLOTHING: () => t('pfm.mainCategories.CLOTHING'),
    COMMUNICATION: () => t('pfm.mainCategories.COMMUNICATION'),
    LEISURE: () => t('pfm.mainCategories.LEISURE'),
    EDUCATION: () => t('pfm.mainCategories.EDUCATION'),
    CAR: () => t('pfm.mainCategories.CAR'),
    TRANSPORT: () => t('pfm.mainCategories.TRANSPORT'),
    TRAVEL_HOLIDAYS: () => t('pfm.mainCategories.TRAVEL_HOLIDAYS'),
    WITHDRAWAL: () => t('pfm.mainCategories.WITHDRAWAL'),
    ALIMONY_POCKET_MONEY: () => t('pfm.mainCategories.ALIMONY_POCKET_MONEY'),
    ONLINE_SHOPPING: () => t('pfm.mainCategories.ONLINE_SHOPPING'),
    SAVINGS_INVESTMENT: () => t('pfm.mainCategories.SAVINGS_INVESTMENT'),
    TAXES: () => t('pfm.mainCategories.TAXES'),
    FEES: () => t('pfm.mainCategories.FEES'),
    OTHER_EXPENSES: () => t('pfm.mainCategories.OTHER_EXPENSES'),
    UNCATEGORIZED_EXPENSE: () => t('pfm.mainCategories.UNCATEGORIZED_EXPENSE'),
    REGULAR_INCOME: () => t('pfm.mainCategories.REGULAR_INCOME'),
    NON_REGULAR_INCOME: () => t('pfm.mainCategories.NON_REGULAR_INCOME'),
    UNCATEGORIZED_INCOME: () => t('pfm.mainCategories.UNCATEGORIZED_INCOME'),
};

export const SUB_CATEGORY_TRANSLATION: Record<SubCategoryName, () => string> = {
    RENT: () => t('pfm.subCategories.RENT'),
    HOUSE_LOAN: () => t('pfm.subCategories.HOUSE_LOAN'),
    ENERGY: () => t('pfm.subCategories.ENERGY'),
    UTILITY_BILLS: () => t('pfm.subCategories.UTILITY_BILLS'),
    WASTE_DISPOSAL: () => t('pfm.subCategories.WASTE_DISPOSAL'),
    SEWER_FEES: () => t('pfm.subCategories.SEWER_FEES'),
    INSURANCE: () => t('pfm.subCategories.INSURANCE'),
    FURNITURE: () => t('pfm.subCategories.FURNITURE'),
    IMPROVEMENTS_AND_FURNITURE: () => t('pfm.subCategories.IMPROVEMENTS_AND_FURNITURE'),
    CLEANING: () => t('pfm.subCategories.CLEANING'),
    PET_CARE: () => t('pfm.subCategories.PET_CARE'),
    OTHER_LIVING_AND_ENERGY: () => t('pfm.subCategories.OTHER_LIVING_AND_ENERGY'),
    FOOD_SHOPPING: () => t('pfm.subCategories.FOOD_SHOPPING'),
    RESTAURANT: () => t('pfm.subCategories.RESTAURANT'),
    OTHER_FOOD: () => t('pfm.subCategories.OTHER_FOOD'),
    DRUGSTORE: () => t('pfm.subCategories.DRUGSTORE'),
    PHARMACY: () => t('pfm.subCategories.PHARMACY'),
    COSMETICS: () => t('pfm.subCategories.COSMETICS'),
    DOCTORS_HOSPITAL: () => t('pfm.subCategories.DOCTORS_HOSPITAL'),
    LIFE_HEALTH_INSURANCE: () => t('pfm.subCategories.LIFE_HEALTH_INSURANCE'),
    OTHER_HEALTH: () => t('pfm.subCategories.OTHER_HEALTH'),
    FASHION: () => t('pfm.subCategories.FASHION'),
    SHOES: () => t('pfm.subCategories.SHOES'),
    ACCESSORIES: () => t('pfm.subCategories.ACCESSORIES'),
    OTHER_CLOTHING: () => t('pfm.subCategories.OTHER_CLOTHING'),
    PHONE_BILLS: () => t('pfm.subCategories.PHONE_BILLS'),
    TELEVISION: () => t('pfm.subCategories.TELEVISION'),
    INTERNET: () => t('pfm.subCategories.INTERNET'),
    ENTERTAINMENT_ELECTRONICS: () => t('pfm.subCategories.ENTERTAINMENT_ELECTRONICS'),
    AMUSEMENT: () => t('pfm.subCategories.AMUSEMENT'),
    HOBBIES_SPORT: () => t('pfm.subCategories.HOBBIES_SPORT'),
    HOBBIES_COTTAGE_GARDEN: () => t('pfm.subCategories.HOBBIES_COTTAGE_GARDEN'),
    READING: () => t('pfm.subCategories.READING'),
    TOYS_GAMES: () => t('pfm.subCategories.TOYS_GAMES'),
    TOBACCONIST: () => t('pfm.subCategories.TOBACCONIST'),
    BETTING: () => t('pfm.subCategories.BETTING'),
    OTHER_LEISURE: () => t('pfm.subCategories.OTHER_LEISURE'),
    KINDERGARTEN_SCHOOL_UNIVERSITY: () => t('pfm.subCategories.KINDERGARTEN_SCHOOL_UNIVERSITY'),
    BOOKS_SUPPLIES: () => t('pfm.subCategories.BOOKS_SUPPLIES'),
    TUITION: () => t('pfm.subCategories.TUITION'),
    OTHER_EDUCATION: () => t('pfm.subCategories.OTHER_EDUCATION'),
    CAR_PURCHASE_LOAN: () => t('pfm.subCategories.CAR_PURCHASE_LOAN'),
    GAS_FUEL: () => t('pfm.subCategories.GAS_FUEL'),
    CAR_MAINTENANCE: () => t('pfm.subCategories.CAR_MAINTENANCE'),
    CAR_INSURANCE: () => t('pfm.subCategories.CAR_INSURANCE'),
    PARKING: () => t('pfm.subCategories.PARKING'),
    TOLLS: () => t('pfm.subCategories.TOLLS'),
    OTHER_CAR: () => t('pfm.subCategories.OTHER_CAR'),
    PUBLIC_TRANSPORT: () => t('pfm.subCategories.PUBLIC_TRANSPORT'),
    TAXI: () => t('pfm.subCategories.TAXI'),
    OTHER_TRANSPORT: () => t('pfm.subCategories.OTHER_TRANSPORT'),
    HOLIDAY_ACCOMODATION: () => t('pfm.subCategories.HOLIDAY_ACCOMODATION'),
    HOLIDAY_FOOD_DRINKS: () => t('pfm.subCategories.HOLIDAY_FOOD_DRINKS'),
    HOLIDAY_EXPENSES: () => t('pfm.subCategories.HOLIDAY_EXPENSES'),
    FOREIGN_CURRENCY: () => t('pfm.subCategories.FOREIGN_CURRENCY'),
    OTHER_HOLIDAY: () => t('pfm.subCategories.OTHER_HOLIDAY'),
    ATM_WITHDRAWAL: () => t('pfm.subCategories.ATM_WITHDRAWAL'),
    BRANCH_WITHDRAWAL: () => t('pfm.subCategories.BRANCH_WITHDRAWAL'),
    CREDIT_CARD_WITHDRAWAL: () => t('pfm.subCategories.CREDIT_CARD_WITHDRAWAL'),
    CREDIT_CARD_BILL: () => t('pfm.subCategories.CREDIT_CARD_BILL'),
    QUICK_CHARGING: () => t('pfm.subCategories.QUICK_CHARGING'),
    OTHER_WITHDRAWAL: () => t('pfm.subCategories.OTHER_WITHDRAWAL'),
    POCKET_MONEY: () => t('pfm.subCategories.POCKET_MONEY'),
    ALIMONEY: () => t('pfm.subCategories.ALIMONEY'),
    OTHER_ALIMONY_POCKET_MONEY: () => t('pfm.subCategories.OTHER_ALIMONY_POCKET_MONEY'),
    UNCATEGORIZED_ONLINE_SHOPPING: () => t('pfm.subCategories.UNCATEGORIZED_ONLINE_SHOPPING'),
    SAVINGS: () => t('pfm.subCategories.SAVINGS'),
    BUILDING_SOCIETY: () => t('pfm.subCategories.BUILDING_SOCIETY'),
    CAPITALIZATION_PRODUCTS: () => t('pfm.subCategories.CAPITALIZATION_PRODUCTS'),
    SECURITIES: () => t('pfm.subCategories.SECURITIES'),
    OTHER_SAVINGS: () => t('pfm.subCategories.OTHER_SAVINGS'),
    PERSONAL_INCOME_TAX: () => t('pfm.subCategories.PERSONAL_INCOME_TAX'),
    VALUE_ADDED_TAX: () => t('pfm.subCategories.VALUE_ADDED_TAX'),
    OTHER_TAXES: () => t('pfm.subCategories.OTHER_TAXES'),
    INTERNAL_TRANSFERS: () => t('pfm.subCategories.INTERNAL_TRANSFERS'),
    FEES: () => t('pfm.subCategories.FEES'),
    INTERESTS: () => t('pfm.subCategories.INTERESTS'),
    LENDING: () => t('pfm.subCategories.LENDING'),
    OTHER_FEES: () => t('pfm.subCategories.OTHER_FEES'),
    FINANCING: () => t('pfm.subCategories.FINANCING'),
    INSURANCE_PREMIUM: () => t('pfm.subCategories.INSURANCE_PREMIUM'),
    UNKNOWN_INSURANCE: () => t('pfm.subCategories.UNKNOWN_INSURANCE'),
    SOCIAL_INSURANCE: () => t('pfm.subCategories.SOCIAL_INSURANCE'),
    GIFTS: () => t('pfm.subCategories.GIFTS'),
    DONATIONS: () => t('pfm.subCategories.DONATIONS'),
    PENALTIES_GOVERNMENTS: () => t('pfm.subCategories.PENALTIES_GOVERNMENTS'),
    OTHER_FINANCING: () => t('pfm.subCategories.OTHER_FINANCING'),
    UNCATEGORIZED_EXPENSE: () => t('pfm.subCategories.UNCATEGORIZED_EXPENSE'),
    SALARY: () => t('pfm.subCategories.SALARY'),
    PENSION: () => t('pfm.subCategories.PENSION'),
    BUSINESS_INCOME: () => t('pfm.subCategories.BUSINESS_INCOME'),
    UNEMPLOYMENT_COMPENSATION: () => t('pfm.subCategories.UNEMPLOYMENT_COMPENSATION'),
    MATERNITY_LEAVE: () => t('pfm.subCategories.MATERNITY_LEAVE'),
    FAMILY_ALLOWANCE: () => t('pfm.subCategories.FAMILY_ALLOWANCE'),
    ALIMONY: () => t('pfm.subCategories.ALIMONY'),
    OTHER_REGULAR_INCOME: () => t('pfm.subCategories.OTHER_REGULAR_INCOME'),
    EXTERNAL_TRANSFERS_INCOMING: () => t('pfm.subCategories.EXTERNAL_TRANSFERS_INCOMING'),
    RENTAL: () => t('pfm.subCategories.RENTAL'),
    CASH_DEPOSIT: () => t('pfm.subCategories.CASH_DEPOSIT'),
    OVERTIME_TRAVEL_COMPENSATION: () => t('pfm.subCategories.OVERTIME_TRAVEL_COMPENSATION'),
    INTERNAL_TRANSFER: () => t('pfm.subCategories.INTERNAL_TRANSFER'),
    ONLINE_SHOP: () => t('pfm.subCategories.ONLINE_SHOP'),
    REIMBURSEMENT: () => t('pfm.subCategories.REIMBURSEMENT'),
    SAVINGS_INVESTMENT_INCOME: () => t('pfm.subCategories.SAVINGS_INVESTMENT_INCOME'),
    INSURANCE_INCOME: () => t('pfm.subCategories.INSURANCE_INCOME'),
    OTHER_NON_REGULAR_INCOME: () => t('pfm.subCategories.OTHER_NON_REGULAR_INCOME'),
    UNCATEGORIZED_INCOME: () => t('pfm.subCategories.UNCATEGORIZED_INCOME'),
    PROPERTY_INSURANCE: () => t('pfm.subCategories.PROPERTY_INSURANCE'),
    PIP_INSURANCE: () => t('pfm.subCategories.PIP_INSURANCE'),
    COSMETICS_AND_APPEARANCE: () => t('pfm.subCategories.COSMETICS_AND_APPEARANCE'),
    LIFE_INSURANCE: () => t('pfm.subCategories.LIFE_INSURANCE'),
    ACCIDENT_INSURANCE: () => t('pfm.subCategories.ACCIDENT_INSURANCE'),
    HEALTH_INSURANCE: () => t('pfm.subCategories.HEALTH_INSURANCE'),
    RISK_LIFE_INSURANCE: () => t('pfm.subCategories.RISK_LIFE_INSURANCE'),
    TRAVEL_INSURANCE: () => t('pfm.subCategories.TRAVEL_INSURANCE'),
    CASH_WITHDRAWAL: () => t('pfm.subCategories.CASH_WITHDRAWAL'),
    PRIVATE_CONTRIBUTION: () => t('pfm.subCategories.PRIVATE_CONTRIBUTION'),
    AMAZON: () => t('pfm.subCategories.AMAZON'),
    GOOGLE: () => t('pfm.subCategories.GOOGLE'),
    ONLINE_SHOPS: () => t('pfm.subCategories.ONLINE_SHOPS'),
    WEB_SERVICES: () => t('pfm.subCategories.WEB_SERVICES'),
    CRYPTOCURRENCY: () => t('pfm.subCategories.CRYPTOCURRENCY'),
    INVESTMENTPLAN: () => t('pfm.subCategories.INVESTMENTPLAN'),
    NOBLE_METAL: () => t('pfm.subCategories.NOBLE_METAL'),
    PENSION_INSURANCE: () => t('pfm.subCategories.PENSION_INSURANCE'),
    PENSION_INVESTMENT: () => t('pfm.subCategories.PENSION_INVESTMENT'),
    EXTERNAL_TRANSFERS: () => t('pfm.subCategories.EXTERNAL_TRANSFERS'),
    TAXES: () => t('pfm.subCategories.TAXES'),
    COLLECTION: () => t('pfm.subCategories.COLLECTION'),
    DONATIONS_ASSOCIATION: () => t('pfm.subCategories.DONATIONS_ASSOCIATION'),
    LIABILITY_INSURANCE: () => t('pfm.subCategories.LIABILITY_INSURANCE'),
    PAYMENT_PROTECTION_INSURANCE: () => t('pfm.subCategories.PAYMENT_PROTECTION_INSURANCE'),
    INCOME_PROTECTION_INSURANCE: () => t('pfm.subCategories.INCOME_PROTECTION_INSURANCE'),
    CRYPTO_INCOME: () => t('pfm.subCategories.CRYPTO_INCOME'),
    INVESTMENT_INCOME: () => t('pfm.subCategories.INVESTMENT_INCOME'),
    SAVINGS_INCOME: () => t('pfm.subCategories.SAVINGS_INCOME'),
    BANK_INFO: () => t('pfm.subCategories.BANK_INFO'),
    LEGAL_INSURANCE: () => t('pfm.subCategories.LEGAL_INSURANCE'),
    PET_INSURANCE: () => t('pfm.subCategories.PET_INSURANCE'),
    DISABILITY_INSURANCE: () => t('pfm.subCategories.DISABILITY_INSURANCE'),
    CYBER_INSURANCE: () => t('pfm.subCategories.CYBER_INSURANCE'),
};
